import { Link } from "react-router-dom";

const AboutHeroSection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "Terms & Conditions",
      home: "Home",
      page: "Terms & Conditions",
    },
    zh: {
      title: "条款与条件",
      home: "首页",
      page: "条款与条件",
    },
  };

  return (
    <section
      className="relative py-16 md:py-28 text-center overflow-hidden"
      style={{
        backgroundImage:
          "url('/assets/images/successful-businessman-overlooking-city-skyline-with-stock-charts.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >

      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative max-w-[900px] mx-auto px-4">

        <h1 className="text-5xl md:text-6xl font-medium text-white mb-6">
          {text[lang].title}
        </h1>

        <div className="inline-flex items-center gap-3 bg-[#C09F7C] text-white px-6 py-3 rounded-full text-sm font-medium mb-8">

          <Link to="/" className="hover:opacity-80">
            {text[lang].home}
          </Link>

          <span>→</span>

          <span className="text-white">
            {text[lang].page}
          </span>

        </div>

      </div>
    </section>
  );
};

export default AboutHeroSection;